interface AuthResponse {
  status: boolean;
  message?: string;
  user: {
    userId: string;
    email: string;
    name: string;
    employeeId: string;
    adminApproval: boolean;
    isDeleted: boolean;
    isActive: boolean;
    userType: number;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
    updatedBy: string;
    role: {
      id: number;
      roleId: string;
      roleName: string;
    };
    employee: {
      rcRegionCode: string;
      empLastName?: string;
      empFirstName?: string;
      empAuthorization?: string;
      empAuthorization2?: string;
      empFullName?: string;
      empAeId?: string;
    };
  };
}

export const validateToken = async (token?: string): Promise<AuthResponse | null> => {
  try {
    const accessToken = token;

    if (!accessToken) {
      throw new Error('No access token found');
    }

    const response = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/validate`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        device: navigator.userAgent,
        ipAddress: '', // Will be handled by backend
      },
    });

    const data = (await response.json()) as AuthResponse;

    if (response.ok && data?.status) {
      return data;
    } else {
      throw new Error(data.message ?? 'Validation failed');
    }
  } catch (error) {
    console.error('Token validation error:', error);
    return null;
  }
};
